export enum Steps {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}
